import React, { Component } from 'react'
import JewelryPanel from '../../jewelry-panel'
import Spacer from '../../../../components/spacer'
import SelectItem from '../../../../components/select-item'
import {showHaloSideDiamondPanel} from '../../../../utils/jewelry-validation'

class HaloSideDiamondPanel extends Component {
  render () {
    const props = this.props
    return (
      <JewelryPanel
        id='diamondsOnOutsideSidesPanel'
        show={showHaloSideDiamondPanel(props)}
        isResetting={props.isResetting}>

        <Spacer xxs />

        <SelectItem
          id='diamonds_on_outside_of_halo'
          label='Diamonds on Outside Sides of Halo'
          labelId='halo_side_diamond'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.diamonds_on_outside_of_halo}
          onChange={props.onChangeVal.bind(this, 'diamonds_on_outside_of_halo')}
          initVal={null}
        />

        <JewelryPanel
          id='diamondsOnOutsideOfHaloContent'
          show={props.diamonds_on_outside_of_halo === true}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            label='Quality of Diamonds on Outside Sides of Halo'
            id='diamondsOnOutsideSidesQuality'
            labelId='diamond_on_outside_of_halo_quality'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.quality_of_diamonds_on_outside_of_halo}
            onChange={props.onChangeVal.bind(this, 'quality_of_diamonds_on_outside_of_halo')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='settingStyleOfDiamondsOnOutsideOfHalo'
            label='Setting Style of Diamonds on Outside Sides of Halo'
            labelId='setting_style_of_diamonds_on_outside_of_halo'
            options={[
              {value: 'pave_border', label: 'Pavé w/ Border'},
              {value: 'channel_set', label: 'Channel Set'}
            ]}
            value={props.setting_style_of_diamonds_on_outside_of_halo}
            onChange={props.onChangeVal.bind(this, 'setting_style_of_diamonds_on_outside_of_halo')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='milgrainOnOutsideOfHalo'
            label='Milgrain on Outside Sides of Halo'
            labelId='milgrain_on_outside_of_halo'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.milgrain_on_outside_of_halo}
            onChange={props.onChangeVal.bind(this, 'milgrain_on_outside_of_halo')}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default HaloSideDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/centre-halo-panel/halo-side-diamond-panel/index.js